import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import { PROMPT_CATEGORIES, type PromptCategory } from '../model/prompts';

type Props = { value: PromptCategory | null; onChange: (category: PromptCategory | null) => void };

/** "All" plus one pill per category; the chosen one is filled. */
export function PromptFilters({ value, onChange }: Props) {
  const options: [string, PromptCategory | null][] = [['All', null], ...PROMPT_CATEGORIES.map((c): [string, PromptCategory] => [c, c])];
  return (
    <Stack direction="row" role="group" aria-label="Filter prompts" sx={{ gap: 0.75, flexWrap: 'wrap' }}>
      {options.map(([label, category]) => {
        const isOn = category === value;
        return (
          <ButtonBase key={label} aria-pressed={isOn} onClick={() => { onChange(category); }} sx={pillSx(isOn)}>
            {label}
          </ButtonBase>
        );
      })}
    </Stack>
  );
}

const pillSx = (isOn: boolean) => ({
  height: 28,
  px: 1.5,
  borderRadius: 14,
  fontSize: '0.75rem',
  fontWeight: 500,
  border: 1,
  borderColor: isOn ? 'text.primary' : 'divider',
  bgcolor: isOn ? 'text.primary' : 'background.paper',
  color: isOn ? 'background.paper' : 'text.primary',
  transition: 'background-color 150ms, color 150ms, border-color 150ms',
  '&:hover': { borderColor: isOn ? 'text.primary' : 'surface.border' },
});
